<div class="p-grid">
  <div class="p-col-12 p-mb-12">
    <p-card>
      <p-tabView>
        <p-tabPanel header="Frontend">
          <div class="p-fluid">
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
              <div class="p-col-6 p-md-6">
                <p class="texto">{{aplicacao.nome}} </p>
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Versão: </label>
              <div class="p-col-6 p-md-6">
                <p class="versao">{{aplicacao.versao}}</p>
              </div>
            </div>
            <div class="p-field p-grid">
              <label  class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Ambiente: </label>
              <div class="p-col-6 p-md-6">
                <p class="texto">{{aplicacao.versao}}</p>
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data de compilação: </label>
              <div class="p-col-6 p-md-6">
                <p class="texto">{{aplicacao.dataCompilacao}}</p>
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Commit SHA: </label>
              <div class="p-col-6 p-md-6">
                <p class="texto">{{aplicacao.commitSha}}</p>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Backend">
          <p-tabView>
            <p-tabPanel header="Dados">
              <div class="p-fluid">
                <div *ngIf="aplicacaoDados">
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.nome}}</p>
                    </div>
                  </div>
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Versão: </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.versao}}</p>
                    </div>
                  </div>
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Ambiente: </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.ambiente}}</p>
                    </div>
                  </div>
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data de compilação:
                    </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.dataCompilacao}}</p>
                    </div>
                  </div>
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Commit SHA: </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.commitSha}}</p>
                    </div>
                  </div>
                  <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Pipeline Id: </label>
                    <div class="p-col-6 p-md-6">
                      <p class="texto">{{aplicacaoDados.pipelineId}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Sistema" *ngIf="aplicacaoDadosSistema">
              <div class="p-fluid">
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Hostname: </label>
                  <div class="p-col-6 p-md-6">
                    <p class="texto">{{aplicacaoDadosSistema.hostname}} </p>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Tipo: </label>
                  <div class="p-col-6 p-md-6">
                    <p class="texto">{{aplicacaoDadosSistema.tipo}} </p>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Versão: </label>
                  <div class="p-col-6 p-md-6">
                    <p class="texto">{{aplicacaoDadosSistema.versao}} </p>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Locale: </label>
                  <div class="p-col-6 p-md-6">
                    <div>
                      <ul>
                        <li><span class="p-text-bold"> Nome: </span>{{aplicacaoDadosSistema.locale.nome}}</li>
                        <li><span class="p-text-bold"> Pais: </span> {{aplicacaoDadosSistema.locale.pais}}</li>
                        <li><span class="p-text-bold">Linguagem: </span>{{aplicacaoDadosSistema.locale.linguagem}} </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">TimeZone: </label>
                  <div class="p-col-6 p-md-6">
                    <div>
                      <ul>
                        <li><span class="p-text-bold"> id: </span>{{aplicacaoDadosSistema.timeZone.id}}</li>
                        <li><span class="p-text-bold"> Pais: </span> {{aplicacaoDadosSistema.timeZone.nome}}</li>
                        <li><span class="p-text-bold"> Pais: </span> {{aplicacaoDadosSistema.timeZone.horarioLocal}}</li>
                        <li><span class="p-text-bold">Linguagem:
                          </span>{{aplicacaoDadosSistema.timeZone.horarioLocalPorExtenso}} </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Memória: </label>
                  <div class="p-col-6 p-md-6">
                    <div>
                      <ul>
                        <li><span class="p-text-bold"> id: </span>{{aplicacaoDadosSistema.memoria.total}}</li>
                        <li><span class="p-text-bold"> Pais: </span> {{aplicacaoDadosSistema.memoria.livre}}</li>
                        <li><span class="p-text-bold"> Pais: </span> {{aplicacaoDadosSistema.memoria.usada}}</li>
                        <li><span class="p-text-bold">Linguagem: </span>{{aplicacaoDadosSistema.memoria.maxima}} </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Charset: </label>
                  <div class="p-col-6 p-md-6">
                    <p class="texto">{{aplicacaoDadosSistema.charset}} </p>
                  </div>
                </div>
                <div class="p-field p-grid">
                  <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Processadores: </label>
                  <div class="p-col-6 p-md-6">
                    <p class="texto">{{aplicacaoDadosSistema.processadores}} </p>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Configurações">
              <pre>{{aplicacaoDados | json}}</pre>
            </p-tabPanel>
          </p-tabView>
        </p-tabPanel>
      </p-tabView>
    </p-card>
  </div>
</div>
